module.exports = __webpack_public_path__ + "img/cave129.cd53e92d.jpg";